var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('app-login-layout',{attrs:{"mode":_vm.mode,"isLogIn":true,"title":"Start your Platinum Online Trial today"}},[_c('template',{slot:"form_top"},[_c('div',[_vm._v("Select type of an account:")])]),_c('template',{slot:"fields"},[_vm._l((_vm.accountTypes),function(ref){
var label = ref.label;
var link = ref.link;
return [_c('v-btn',{key:link,staticClass:"blueLighten signup__btn",attrs:{"large":"","text":_vm.currentLink !== link},on:{"click":function($event){_vm.currentLink = link;
          _vm.next();}}},[_vm._v(" "+_vm._s(label)+" ")])]})],2)],2)}
var staticRenderFns = []

export { render, staticRenderFns }